import PreviewSection from '../../PreviewSection'

export default function EstimateVsActualHTMLPreviewHeaderSection() {}

EstimateVsActualHTMLPreviewHeaderSection.prototype = new PreviewSection();

EstimateVsActualHTMLPreviewHeaderSection.prototype.init = function( groupingLevelsArray, columnsStrategy ) {
    PreviewSection.prototype.init.call( this );
    this.groupingLevelsArray = groupingLevelsArray;
    this.columnsStrategy = columnsStrategy;
    
    return this;
};

EstimateVsActualHTMLPreviewHeaderSection.prototype.addRows = function( tBody )
{
    const row1 = this.createRow("headerRow firstHeaderRow")
    this.addCell( row1, ReportPreviewUtils.makeGroupingHeader(this.groupingLevelsArray), "groupingLevelsTitle", 1, 3);
    this.columnsStrategy.addFirstHeaderRowCells(row1);
    this.addRow( tBody, row1 );

    const row2 = this.createRow("headerRow secondHeaderRow")
    this.columnsStrategy.addSecondHeaderRowCells(row2);
    this.addRow( tBody, row2 );

    const row3 = this.createRow("headerRow thirdHeaderRow")
    this.columnsStrategy.addThirdHeaderRowCells(row3);
    this.addRow( tBody, row3 );
};



// WEBPACK FOOTER //
// ./web/js/reports/preview/html/eva/EstimateVsActualHTMLPreviewHeaderSection.js